// Drehorte für die LocationsMap. Lon/Lat sind echte Geo-Koordinaten,
// werden in LocationsMap.js auf den BW-SVG-viewBox projiziert.
//
// category: "auto" | "recruiting" | "wedding" | "city" | "product" | "social" | "home" | "real-estate"
// video / poster: optional, wird im Pin-Tooltip als LazyVideo angezeigt
//
const R2 = "https://pub-626563a90a7f431c96f87c5838c120bc.r2.dev";

const locations = [
  {
    id: "villingen-schwenningen",
    name: "Villingen-Schwenningen",
    address: "Altstadt & Münsterplatz, 78050 Villingen-Schwenningen",
    region: "Schwarzwald-Baar-Kreis",
    lon: 8.4593,
    lat: 48.0610,
    category: "home",
    home: true,
    projects: [
      "Home Base · Studio",
      "Stadt VS — Weihnachtsmärkte 2024",
      "Stadt VS — Abendflair / Wochenmarkt",
      "Seedos Produktkampagne",
      "Startup-Förderung VS",
      "KOD — Kommunales Ordnungsamt Recruiting",
      "Izumi E-Gym — Eröffnung Villingen",
    ],
    video: `${R2}/videos/vs-weihnachtmaerkte-rueckblick-2024.mp4`,
    poster: "/thumbnails/loc-villingen-schwenningen.webp",
    aspect: "9/16",
    heroImage: `${R2}/images/vs-hero-stadtbibliothek.webp`,
    description:
      "Mein Heimathafen. Villingen-Schwenningen ist das Tor zum Schwarzwald — vielfältig, lebendig, fotogen. Von den Weihnachtsmärkten in der Altstadt bis zum Wochenmarkt am Münsterplatz, von Seedos-Drehs in lokalen Cafés bis zu Stadt-Kampagnen für die Wirtschaftsförderung. Auch traditionelle Events wie der Kuhreihen in der Altstadt-Mitte und das Neujahrsschießen am Hubenloch werden hier festgehalten — Brauchtum, das ich gerne in Bildern für die Stadt dokumentiere.",
    bestFor: ["Stadt-Marketing", "Event-Coverage", "Brauchtum / Tradition", "Lifestyle Reels", "Recruiting in lokalen Unternehmen"],
    tips: [
      "Wochenmärkte (Mi/Fr) sind perfekte Authentik-Locations",
      "Münsterplatz im Sonnenuntergang gibt warmes Licht ohne Reflektoren",
      "Kuhreihen in der Altstadt: enge Gassen → Tele-Linse für Komprimierung",
      "Neujahrsschießen am Hubenloch: Sonnenaufgang + Lärm-Schutz für Mics",
      "Drohnenfreigabe für Stadtbereich: vorab DFS-Antrag"
    ],
    relatedCases: [{ slug: "stadt-villingen-schwenningen", label: "Stadt VS Marketing-Case" }],
    relatedVideos: [
      `${R2}/videos/vs-weihnachtmaerkte-rueckblick-2024.mp4`,
      `${R2}/videos/stadt-villingen-abendflair.mp4`,
      `${R2}/videos/stadt-wochemarkt-video-1.mp4`,
      `${R2}/videos/seedos-der-snack-der-dich-findet.mp4`,
      `${R2}/videos/seedos-allgemein.mp4`,
      `${R2}/videos/seedos-salted.mp4`,
      `${R2}/videos/seedos-einbruch-reel.mp4`,
      `${R2}/videos/01-maedchen-film01-16-9.mp4`,
      `${R2}/videos/02-maedchen-film03-16-9.mp4`,
      `${R2}/videos/03-maedchen-reel-9-16.mp4`,
      `${R2}/videos/kod-recruiting-vs.mp4`,
      `${R2}/videos/izumi-egym-villingen.mp4`,
    ],
    galleryImages: [
      `${R2}/images/vs-kuhreihen-1.webp`,
      `${R2}/images/vs-kuhreihen-2.webp`,
      `${R2}/images/vs-kuhreihen-3.webp`,
      `${R2}/images/vs-kuhreihen-4.webp`,
      `${R2}/images/vs-kuhreihen-5.webp`,
      `${R2}/images/vs-kuhreihen-6.webp`,
      `${R2}/images/vs-kuhreihen-7.webp`,
      `${R2}/images/vs-kuhreihen-8.webp`,
      `${R2}/images/vs-neujahrsschiessen-1.webp`,
      `${R2}/images/vs-neujahrsschiessen-2.webp`,
      `${R2}/images/vs-neujahrsschiessen-3.webp`,
      `${R2}/images/vs-neujahrsschiessen-4.webp`,
      `${R2}/images/vs-neujahrsschiessen-5.webp`,
      `${R2}/images/vs-neujahrsschiessen-6.webp`,
      `${R2}/images/vs-neujahrsschiessen-7.webp`,
      `${R2}/images/vs-neujahrsschiessen-8.webp`,
    ],
  },
  {
    id: "hechingen",
    name: "Hechingen — Villa Eugenia",
    address: "Villa Eugenia, Zollernstraße 10, 72379 Hechingen",
    region: "Zollernalbkreis",
    lon: 8.9620,
    lat: 48.3470,
    category: "auto",
    projects: ["Maybach Landaulet — Villa-Set (Teil 1)"],
    video: `${R2}/videos/maybach-landaulet-bts-2.mp4`,
    poster: "/thumbnails/loc-hechingen.webp",
    aspect: "9/16",
    description:
      "Die Villa Eugenia — ein historisches Kulturzentrum am Fuß der Burg Hohenzollern. Der Förderverein Villa Eugenia e.V. nutzt das Gebäude für Konzerte, Kunstausstellungen und Hochzeiten. Für den Maybach-Landaulet-Dreh war die Villa mit ihrem klassizistischen Fassaden-Look und der Auffahrt das perfekte Set: zeitlos, edel, und visuell stark genug, um einen der seltensten Wagen der Welt zu inszenieren.",
    bestFor: ["Automotive Inszenierung", "Hochzeitsvideos", "Imagefilme mit historischer Architektur", "Event-Coverage"],
    tips: [
      "Auffahrt eignet sich perfekt für Auto-Reveals — Vorab Drehgenehmigung beim Förderverein einholen",
      "Klassizistische Fassade nimmt Lichter & Reflexionen schön an, früher Vormittag = weiches Licht",
      "Burg Hohenzollern als Background für Wide-Shots in 1.5 km Entfernung",
    ],
    relatedCases: [{ slug: "maybach-landaulet-film", label: "Maybach Landaulet Case" }],
    relatedVideos: [`${R2}/videos/maybach-landaulet-bts-2.mp4`],
  },
  {
    id: "konstanz",
    name: "Konstanz",
    address: "Seestraße & Reality Escape, 78462 Konstanz",
    region: "Landkreis Konstanz",
    lon: 9.180,
    lat: 47.6630,
    category: "auto",
    projects: [
      "Maybach Landaulet — Bodensee (Teil 2)",
      "Reality Escape Konstanz — Brand-Film",
    ],
    video: `${R2}/videos/reality-escape-konstanz.mp4`,
    poster: "/thumbnails/reality-escape-konstanz.webp",
    aspect: "16/9",
    description:
      "Konstanz am Bodensee — von der Seestraßen-Promenade mit Imperia-Statue bis zu modernen Indoor-Locations. Zwei sehr unterschiedliche Drehs: einmal Maybach Landaulet entlang des Hafens, einmal ein Brand-Film für Reality Escape Konstanz, einer Escape-Room-Erlebnislocation. Die Stadt liefert Outdoor-Cinematik genauso wie atmosphärische Innenräume.",
    bestFor: ["Automotive am Wasser", "Lifestyle Reels mit Bodensee-Background", "Indoor-Brand-Films", "Sunset / Magic Hour Shoots"],
    tips: [
      "Magic Hour über dem See — westliches Licht ab ca. 19 Uhr (Sommer)",
      "Imperia-Statue als prägnanter visueller Anker im Background",
      "Indoor-Drehs in Konstanzer Locations: oft enge Räume → 24mm + Stabilizer",
      "Drehgenehmigung der Stadt nötig für längere Standzeiten am Hafen",
    ],
    relatedCases: [{ slug: "maybach-landaulet-film", label: "Maybach Landaulet Case" }],
    relatedVideos: [
      `${R2}/videos/maybach-landaulet-bts-2.mp4`,
      `${R2}/videos/reality-escape-konstanz.mp4`,
    ],
  },
  {
    id: "engen",
    name: "Engen / Zimmerholz — Hegauablick",
    address: "Parkplatz L191, Engen-Zimmerholz, 78234 Engen",
    region: "Landkreis Konstanz · Hegau",
    lon: 8.7720,
    lat: 47.8710,
    category: "auto",
    projects: ["Lamborghini Urus SE — Hegauablick", "Porsche 911 Carrera — Hegauablick"],
    video: `${R2}/videos/lamborghini-urus-se.mp4`,
    poster: "/thumbnails/loc-engen.webp",
    aspect: "9/16",
    description:
      "Ein unscheinbarer Parkplatz an der L191 bei Engen-Zimmerholz — und gleichzeitig einer der besten Auto-Drehspots der Region. Freier Blick auf die Hegau-Vulkankegel (Hohenstoffeln, Hohentwiel), kaum Verkehr, weiter Asphalt für Rolling Shots. Erst der Lamborghini Urus SE, dann ein Porsche 911 Carrera — der Hegauablick liefert immer wieder Cinema-Backgrounds.",
    bestFor: ["Automotive Rolling Shots", "Sunrise / Sunset Aufnahmen", "Drohnenflüge mit Vulkan-Hintergrund"],
    tips: [
      "Sunrise im Sommer ab 5:30 Uhr — kaum andere Autos auf der L191",
      "Drohne: Hegau-Vulkankegel von oben sehen wie aus einem anderen Land aus",
      "Wenig Schatten auf dem Parkplatz, also Cooler / Hitze-Schutz für Equipment einplanen",
    ],
    relatedCases: [],
    relatedVideos: [
      `${R2}/videos/lamborghini-urus-se.mp4`,
      `${R2}/videos/porsche-carrera-hegauablick.mp4`,
    ],
  },
  {
    id: "pfullendorf",
    name: "Pfullendorf — Geiger Group HQ",
    address: "Geiger Group Hauptstandort, 88630 Pfullendorf",
    region: "Landkreis Sigmaringen",
    lon: 9.2580,
    lat: 47.9210,
    category: "recruiting",
    projects: ["Servicemitarbeiter (m/w/d) Recruiting", "Geiger Group Spots"],
    video: `${R2}/videos/servicemitarbeiter-mwd.mp4`,
    poster: "/thumbnails/loc-pfullendorf.webp",
    aspect: "9/16",
    description:
      "Hauptstandort der Geiger Group in Pfullendorf — Schauplatz für mehrere Recruiting- und Image-Spots. Werkstattbereich, Büros und Außenflächen geben Zugang zu authentischen Mitarbeiter-Storys: Echte Menschen, echte Arbeitsumgebung, statt aufgesetzter Studio-Sets. Genau das, was Recruiting-Videos heute brauchen, um Talente anzusprechen.",
    bestFor: ["Recruiting / Employer Branding", "Imagefilme im Industrie-Kontext", "Mitarbeiter-Interviews"],
    tips: [
      "Werkstatthalle hat Mischlicht (Tageslicht + Neon) — bedacht weißabgleichen",
      "Ruhige Drehzeiten: vor 7 Uhr morgens oder nach 17 Uhr",
      "Sicherheitseinweisung vorab — geschlossene Schuhe + Warnweste verpflichtend",
    ],
    relatedCases: [{ slug: "geiger-group", label: "Geiger Group Case" }],
    relatedVideos: [`${R2}/videos/servicemitarbeiter-mwd.mp4`],
  },
  {
    id: "moenchweiler",
    name: "Mönchweiler — Weisser & Griesshaber",
    address: "Weisser und Griesshaber GmbH, 78087 Mönchweiler",
    region: "Schwarzwald-Baar-Kreis",
    lon: 8.4150,
    lat: 48.0890,
    category: "recruiting",
    projects: ["Weisser & Griesshaber Recruiting Video 2022"],
    video: `${R2}/videos/weisser-und-griesshaber-gmbh-recruiting-video-2022.mp4`,
    poster: "/thumbnails/loc-moenchweiler.webp",
    aspect: "9/16",
    description:
      "Mittelständischer Industriebetrieb im Schwarzwald — Weisser und Griesshaber GmbH in Mönchweiler. Für das Recruiting-Video 2022 vor Ort gefilmt: in den Produktionshallen, an Maschinen und mit echten Mitarbeitern. Ergebnis: ein authentischer Cut, der Bewerber durch Realität überzeugt — nicht durch Hochglanz.",
    bestFor: ["Recruiting in der Fertigung / Industrie", "Mitarbeiter-Interviews", "Imagefilme Mittelstand"],
    tips: [
      "Industrielärm: Lavalier-Mics + Nachvertonung im Studio einplanen",
      "Maschinen + LED-Streifen für visuelle Akzente nutzen",
      "Sicherheitskleidung sichtbar tragen (signalisiert Realismus)",
    ],
    relatedCases: [{ slug: "corporate-recruiting", label: "Corporate Recruiting Case" }],
    relatedVideos: [`${R2}/videos/weisser-und-griesshaber-gmbh-recruiting-video-2022.mp4`],
  },
  {
    id: "koenigsfeld",
    name: "Königsfeld — Fiehn Gebäudeautomation",
    address: "Fiehn Gebäudeautomation GmbH, Burgberger Str. 14, 78126 Königsfeld im Schwarzwald",
    region: "Schwarzwald-Baar-Kreis",
    lon: 8.3490,
    lat: 48.1430,
    category: "recruiting",
    projects: ["Fiehn Gebäudeautomation Recruiting Reel"],
    video: `${R2}/videos/fiehn-recruting-reel.mp4`,
    poster: "/thumbnails/loc-koenigsfeld.webp",
    aspect: "9/16",
    description:
      "Fiehn Gebäudeautomation GmbH in Königsfeld im Schwarzwald — ein modernes Tech-Unternehmen für Building-Automation. Der Recruiting-Reel kombiniert moderne Technik-Ästhetik (Schaltschränke, Sensoren, Tablets) mit echten Stories der Mitarbeiter. Zeigt: hier wird Zukunft gebaut, nicht nur verwaltet.",
    bestFor: ["Tech-Recruiting", "Reels für moderne Mittelständler", "Image-Spots Building-Automation"],
    tips: [
      "Schaltschränke geben coole, kühle Leds als visuelles Element",
      "Tablets + Bildschirme: Kameraauslösung mit Display-Refresh-Rate synchronisieren (Flicker)",
      "Burgberger Str. mit kleinen Dorfblicken — gute Establishing-Shots aus dem Auto raus",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/fiehn-recruting-reel.mp4`],
  },
  {
    id: "geislingen-balingen",
    name: "Geislingen — Schloss Geislingen",
    address: "Schloss Geislingen, Schloßpl. 5, 72351 Geislingen",
    region: "Zollernalbkreis",
    lon: 8.7510,
    lat: 48.2860,
    category: "wedding",
    projects: ["Hochzeit Sabrina & Christian — Schloss Geislingen"],
    video: `${R2}/videos/hochzeit-von-sabrina-und-christian-15-10-22.mp4`,
    poster: "/thumbnails/loc-geislingen-balingen.webp",
    aspect: "16/9",
    description:
      "Schloss Geislingen — auch bekannt als Sweningers Burghof — eine der beiden historischen Ortsburgen, errichtet um 1490. Heute ist der Schlossplatz eine der atmosphärischsten Hochzeits-Locations im Zollernalbkreis. Für die Hochzeit von Sabrina & Christian der perfekte Rahmen: alte Mauern, weiches Spätsommer-Licht und eine intime Trauung im Hof.",
    bestFor: ["Hochzeitsvideos", "Verlobungs-Shoots", "Historische Imagefilme"],
    tips: [
      "Schlosshof = enge Räume → 24mm + Stabilizer / Gimbal für Bewegung",
      "Außenfassade aus Sandstein nimmt Goldene-Stunde-Licht traumhaft auf",
      "Drehgenehmigung über Stadt Geislingen, Tag-vorher-Anfrage reicht meist",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/hochzeit-von-sabrina-und-christian-15-10-22.mp4`],
  },
  {
    id: "niedereschach",
    name: "Niedereschach — ZUMBLUM Studio",
    address: "ZUMBLUM Filmproduktion und Online Agentur, Rottweiler Str. 30, 78078 Niedereschach",
    region: "Schwarzwald-Baar-Kreis",
    lon: 8.4480,
    lat: 48.1570,
    category: "product",
    projects: ["327 Spirits Produktvideo — Studio-Shoot"],
    video: `${R2}/videos/327-spirti-21-03-25.mp4`,
    poster: "/thumbnails/loc-niedereschach.webp",
    aspect: "9/16",
    description:
      "Bei ZUMBLUM in Niedereschach — Filmproduktion und Online-Agentur mit kompaktem aber gut ausgestattetem Studio. Für den 327 Spirits Produkt-Shoot der ideale Rahmen: kontrollierte Beleuchtung, schwarzer Hintergrund, makro-fähige Lichtsetups für Spirituosen-Closeups. Co-Working mit dem ZUMBLUM-Team — gemeinsam Produktwerbung in Premium-Qualität.",
    bestFor: ["Produktvideos / E-Commerce", "Spirituosen / Premium-Goods Closeups", "Studio-Shoots im Schwarzwald"],
    tips: [
      "Glas-Produkte: Polfilter unverzichtbar gegen Reflexionen",
      "Studio reservierbar — Kontakt direkt über ZUMBLUM",
      "Rottweiler Str. 30 hat Parkplatz vor der Tür — Equipment-Loading easy",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/327-spirti-21-03-25.mp4`],
  },
  {
    id: "deisslingen",
    name: "Deißlingen — Audi S8",
    address: "K5557, 78652 Deißlingen",
    region: "Landkreis Rottweil",
    lon: 8.5965,
    lat: 48.0746,
    category: "auto",
    projects: ["Audi S8 — Reel auf der K5557"],
    video: `${R2}/videos/audi-s8-deisslingen.mp4`,
    poster: "/thumbnails/loc-audi-s8-deisslingen.webp",
    aspect: "9/16",
    description:
      "Eine ruhige Kreisstraße bei Deißlingen — die K5557 zwischen Feldern und sanften Hügeln im Landkreis Rottweil. Geringer Verkehr, gerade Asphaltabschnitte und freier Blick auf den Schwarzwaldrand. Für den Audi S8 die ideale Bühne: schnelle Drive-Bys ohne Verkehrsstress, Sonnenuntergang über offenen Feldern, kein Hintergrund-Lärm.",
    bestFor: ["Automotive Reels", "Driving Shots ohne Verkehr", "Magic-Hour Cuts"],
    tips: [
      "Kreisstraße K5557 morgens 6-8 Uhr nahezu leer — beste Drehzeit",
      "Genug Hardshoulder für Tracking-Shot mit zweitem Wagen",
      "Hügelige Streckenführung gibt natürliche Reveals — Drohne lohnt sich",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/audi-s8-deisslingen.mp4`],
  },
  {
    id: "stuttgart",
    name: "Stuttgart — Reichman Agentur",
    address: "Reichman Agentur, Stuttgart",
    region: "Region Stuttgart",
    lon: 9.1810,
    lat: 48.7780,
    category: "social",
    projects: ["Reichman Agentur — Social Media Reel"],
    video: `${R2}/videos/reichman-agentur-stuttgart.mp4`,
    poster: "/thumbnails/reichman-agentur-stuttgart.webp",
    aspect: "9/16",
    description:
      "Stuttgart als Drehort der Reichman Agentur — urbane Architektur, modernes Office-Setting und der typische Großstadt-Look der Schwabenmetropole. Ideal für Marketing-Reels mit professionellem Business-Vibe.",
    bestFor: ["Agentur-Reels", "Business / Corporate Reels", "Urban Lifestyle Cuts"],
    tips: [
      "Glasfassaden geben coole Reflexionen — Polfilter bei Bedarf",
      "Stuttgart Mitte = enge Straßen → kurze Brennweiten + Stabilizer",
      "Parkplätze fürs Equipment vorab reservieren (City-Maut & Parkraumplanung)",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/reichman-agentur-stuttgart.mp4`],
  },
  {
    id: "weilersbach",
    name: "Weilersbach (Villingen)",
    address: "Weilersbach, 78050 Villingen-Schwenningen",
    region: "Schwarzwald-Baar-Kreis · Stadtteil von Villingen",
    lon: 8.4222,
    lat: 48.0867,
    category: "auto",
    projects: ["Regenszene im Auto — Cinematic Reel"],
    video: `${R2}/videos/regenszene-weilerbach.mp4`,
    poster: "/thumbnails/regenszene-weilerbach.webp",
    aspect: "16/9",
    description:
      "Weilersbach — kleiner Ortsteil von Villingen-Schwenningen mit ruhiger Landstraße durch Felder und Waldstücke. Genau das richtige Setting für eine Regenszene im Auto: nasser Asphalt, atmosphärisches Mischlicht, kein Verkehr. Direkt um die Ecke meiner Home-Base — kurze Wege, schnelle Wettereinsätze möglich.",
    bestFor: ["Cinematic Auto-Drehs", "Regen / Mood Pieces", "Naturkulisse Schwarzwald"],
    tips: [
      "Echter Regen ist Premium-Look — Wetterfenster ausnutzen, Equipment regenfest sichern",
      "Wischer-Choreografie: 1/50 Shutter für realistische Motion-Blur",
      "Forst-Lichteinbrüche durch das Blätterdach geben natürliche Lens-Flares",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/regenszene-weilerbach.mp4`],
  },
  {
    id: "singen-industrie",
    name: "Singen — Industriegebiet",
    address: "Industriegebiet Singen, 78224 Singen (Hohentwiel)",
    region: "Landkreis Konstanz · Hegau",
    lon: 8.8400,
    lat: 47.7600,
    category: "social",
    projects: ["Vespa Club Singen-Hegau — Classic Ride"],
    poster: "/thumbnails/singen-classic-ride-vespa.webp",
    aspect: "9/16",
    description:
      "Industriegebiet von Singen — weiter Asphalt, gerade Strecken durch Bäume, kaum Verkehr am Wochenende. Der Drehort für den Classic Ride des Vespa Club Singen-Hegau: ein ganzer Konvoi historischer Roller, gebogen durch die Straßen, von vorne aus dem Begleitfahrzeug heraus aufgenommen.",
    bestFor: ["Classic Ride / Auto-Konvois", "Lifestyle Reels", "Tracking Shots aus dem Begleitfahrzeug"],
    tips: [
      "Wochenende = freie Industriestraßen ohne LKW-Verkehr",
      "Tracking-Shot aus offenem Kofferraum mit Gimbal — Körper sichern",
      "Vespa-Konvoi liebt Gegenlicht durch die Bäume — Magic Hour bevorzugt",
    ],
    galleryImages: [
      `${R2}/images/singen-classic-ride-vespa.webp`,
    ],
    relatedCases: [],
    relatedVideos: [],
  },
  {
    id: "lahr",
    name: "Lahr — Club Menschmeier",
    address: "Club Menschmeier, 77933 Lahr/Schwarzwald",
    region: "Ortenaukreis · Schwarzwald",
    lon: 7.8688,
    lat: 48.3406,
    category: "social",
    projects: ["Club Menschmeier — Social Media Reel"],
    video: `${R2}/videos/club-menschmeier.mp4`,
    poster: "/thumbnails/club-menschmeier.webp",
    aspect: "9/16",
    description:
      "Club Menschmeier in Lahr — Nightlife-Location im Ortenaukreis am westlichen Rand des Schwarzwalds. Schummriges Licht, Lasershow, energiegeladene Crowd: ein Reel-Setup, das im Feed mit hoher Bewegungs-Frequenz und satten Farben auffällt.",
    bestFor: ["Nightlife / Club Reels", "Event-Highlight-Videos", "Brand-Cooperations mit Club-Events"],
    tips: [
      "Hohe ISO + lichtstarke Lens (f/1.4-1.8) für Crowd-Aufnahmen ohne Aufhellung",
      "Strobo-Light: Shutter auf 1/50 → bewusste Motion-Blur als Stilmittel",
      "Audio: Lavalier am DJ-Pult abnehmen oder Bar-Soundboard tappen",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/club-menschmeier.mp4`],
  },
  {
    id: "friedingen-donautal",
    name: "Friedingen — Donautal",
    address: "Donautal kurz nach Friedingen a.d. Donau, 78570 Mühlheim a.d. Donau",
    region: "Landkreis Tuttlingen · Donautal",
    lon: 8.8500,
    lat: 48.0200,
    category: "auto",
    projects: ["G-Klasse Video — Donautal", "Porsche GT3 — Donautal"],
    video: `${R2}/videos/porsche-gt3-donautal-friedingen.mp4`,
    poster: "/thumbnails/porsche-gt3-donautal-friedingen.webp",
    aspect: "9/16",
    description:
      "Das Donautal bei Friedingen ist eine der atemberaubendsten Autostrecken Süddeutschlands — kurvige Landstraße entlang der jungen Donau, eingerahmt von Kalkfelsen und Buchenwäldern. Wechselndes Licht durch die Bäume, glasklare Reflexionen am Wasser, kaum Durchgangsverkehr. Hier entstanden Reels mit der Mercedes G-Klasse und einem Porsche GT3 — beide profitieren vom Wechsel zwischen offenen Talblicken und engen, schattigen Passagen.",
    bestFor: ["Automotive Rolling Shots", "Naturkulisse für Premium-Marken", "Drohnenflüge im Tal"],
    tips: [
      "Vormittags: Sonne fällt schräg ins Tal, schöne Lichtsäulen durch Bäume",
      "Wasserrefelxionen entlang der Donau für Slow-Mo Cuts mit Spiegelung",
      "Schmale Strasse — Begleitfahrzeug sinnvoll für Tracking-Shots",
    ],
    relatedCases: [],
    relatedVideos: [
      `${R2}/videos/g-klasse-donautal-friedingen.mp4`,
      `${R2}/videos/porsche-gt3-donautal-friedingen.mp4`,
    ],
  },
  {
    id: "neuhausen-ob-eck",
    name: "Neuhausen ob Eck — Flugplatz",
    address: "Take-Off Gewerbepark, 78579 Neuhausen ob Eck",
    region: "Landkreis Tuttlingen",
    lon: 8.9090,
    lat: 47.9610,
    category: "auto",
    projects: ["Porsche GT3 RS — Flugplatz Neuhausen ob Eck"],
    video: `${R2}/videos/porsche-gt3-rs-flugplatz.mp4`,
    poster: "/thumbnails/loc-porsche-gt3-rs-flugplatz.webp",
    aspect: "16/9",
    description:
      "Der Flugplatz Neuhausen ob Eck im Take-Off Gewerbepark — ein ehemaliger Militärstützpunkt mit weiter Start- und Landebahn, perfekt geeignet für Auto-Drehs. Lange Asphaltflächen ohne Verkehr, weiter Horizont, gigantische Hangars als Background. Für den Porsche GT3 RS die Traum-Location: hier gibt es Platz für lange Tracking-Shots, Spin-Outs und cinematische Wide-Aufnahmen, die auf normalen Straßen unmöglich wären.",
    bestFor: ["High-Performance Automotive", "Cinematic Tracking Shots", "Drohnen-Verfolgungen", "Stunt-Inszenierungen"],
    tips: [
      "Vorab Buchung über Take-Off-Park nötig — Tageskonditionen erfragen",
      "Hangar-Tore als visueller Reveal-Frame nutzen",
      "Kein Schatten auf der Bahn — Hitzeschutz für Equipment + Wasser einplanen",
      "Drohne: militärisches Sperrgebiet endet außerhalb des Geländes — Karten checken",
    ],
    relatedCases: [],
    relatedVideos: [`${R2}/videos/porsche-gt3-rs-flugplatz.mp4`],
  },
];

export const categories = {
  home:       { label: "Home Base",  color: "hsl(280, 95%, 70%)" },
  auto:       { label: "Automotive", color: "hsl(20, 95%, 60%)"  },
  recruiting: { label: "Recruiting", color: "hsl(210, 90%, 60%)" },
  wedding:    { label: "Hochzeit",   color: "hsl(330, 80%, 65%)" },
  product:    { label: "Produkt",    color: "hsl(45, 95%, 60%)"  },
  city:       { label: "City / Event", color: "hsl(280, 75%, 60%)" },
  social:     { label: "Social Media", color: "hsl(160, 70%, 55%)" },
  "real-estate": { label: "Immobilien", color: "hsl(190, 80%, 55%)" },
};

export default locations;
